import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './ActiveFilterButton.module.css';
import Icon from '../../Icon';
import cn from 'classnames'

interface ActiveFilterButtonProps {
  label?: string;
  onClick: () => void;
  children?: ReactNode;
  theme: string;
}

const ActiveFilterButton: React.FC<ActiveFilterButtonProps> = ({ label, onClick, children, theme }) => {

  const wrapperClass = cn(styles.wrapper, {
    [styles.light]: theme === 'light',
    [styles.dark]: theme === 'dark',
  });

  return (
    <div
      className={classNames('text_subheaders_sh3', wrapperClass)}
      onClick={onClick}
    >
      {label} {children}
      <Icon name="deleteIcon" width='10px' height='10px'/>
    </div>
  );
};

export default ActiveFilterButton;